'use strict';

var novicell = novicell || {};
var videoElementId = 'videoOverlay';

novicell.videooverlay =
    novicell.videooverlay ||
    (function() {
        function init() {
            var body = document.querySelector('body');
            body.onclick = function(e) {
                if (e.target.classList.contains('a-videoPlayIcon') && !e.target.classList.contains('js-a-videoPlayIcon--noPlay')) {
                    e.stopPropagation();
                    playVideo(e.target.parentNode);
                }
                if (e.target.getAttribute('data-videoid') != null) {
                    e.stopPropagation();
                    playVideo(e.target);
                }
            };
        }
        function adjustVideoHeight() {
            var videoAspectRatio = 16 / 9;
            var overlay = document.getElementById('js-novi-overlay2');
            if (overlay == null) {
                overlay = document.getElementById('js-novi-overlay');
            }
            if (overlay != null) {
                var videoOverlay = overlay.querySelector('.novi-overlay__content--video');
                if (videoOverlay != null) {
                    var videoHeight, videoWidth;
                    var videoMaxHeight = window.innerHeight - 120;
                    var videoMaxWidth = window.innerWidth - 30;
                    var correspondingWidth = videoMaxHeight * videoAspectRatio;

                    videoWidth = correspondingWidth;
                    videoHeight = videoMaxHeight;
                    if (correspondingWidth > videoMaxWidth) {
                        videoWidth = videoMaxWidth;
                        var correspondingHeight = videoWidth * (1 / videoAspectRatio);
                        videoHeight = correspondingHeight;
                    }
                    videoOverlay.style.width = videoWidth + 'px';
                    videoOverlay.style.height = videoHeight + 'px';
                }
            }
        }
        function playVideo(el) {
            //get video ID from HTML
            var videoId = el.getAttribute('data-videoid');
            //HTML element that should hold the video
            // var videoOverlay = document.getElementById(videoElementId);
            // if(videoOverlay!= null){videoOverlay.parentNode.removeChild(videoOverlay);}
            if (novicell.helpers.closestByClass(el, 'novi-overlay__content') != null) {
                // if video link is in overlay
                novicell.overlay2.create({
                    class: 'selector-overlay',
                    videoId: videoId,
                    type: 'youtube',
                    autoplay: true
                });
            } else {
                novicell.overlay.create({
                    class: 'selector-overlay',
                    videoId: videoId,
                    type: 'youtube',
                    autoplay: true
                });
            }

            adjustVideoHeight();
            window.addEventListener('resize', novicell.debounce(adjustVideoHeight, 250));
        }

        return {
            init: init
        };
    })();
